import { toast } from "react-toastify";
import { hasError } from "src/services/ApiHelpers";

export function handleResponseError(error) {
  const errorResponse = hasError(error);
  toast.error(errorResponse.message);
}


export function handleCheckIsActiveStatus(isActive, id) {
  return id ? isActive : true;
}

export function handleCheckIsDirty(formState) {
  return Object.keys(formState.dirtyFields).length > 0;
}

export function getQueryParamsFromFilter(filters) {
  return Object.keys(filters)
    .filter((k) => filters[k])
    .map((k) => k + "=" + filters[k])
    .join("&");
}

export const getUniqueString = (): string => {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const length = characters.length;
  let counter = 0;
  while (counter < 21) {
    result += characters.charAt(Math.floor(Math.random() * length));
    counter += 1;
  }
  return result;
};
